import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../SettingsPage/index.css';

const PrivacyPolicyPage = () => {
    const navigate = useNavigate();

    return (
        <div className="settings-page-wrapper">
            <div className="settings-header">
                <span className="settings-back-arrow" onClick={() => navigate(-1)}>‹</span>
                <h1 className="settings-title">Privacy Policy</h1>
            </div>

            <div className="settings-container-card text-content-card">
                <h2 className="text-content-title">Privacy Policy</h2>

                <p className="text-content-paragraph">
                    We respect your privacy and are committed to protecting your personal information.
                    This Privacy Policy explains how we collect, use, and safeguard your data when you use our application.
                </p>

                <h3 className="text-content-subtitle">Information We Collect</h3>
                <ul className="text-content-list">
                    <li>Name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Login and usage data</li>
                </ul>

                <h3 className="text-content-subtitle">How We Use Your Information</h3>
                <p className="text-content-paragraph mb-2">We use your information to:</p>
                <ul className="text-content-list">
                    <li>Provide and improve our services</li>
                    <li>Verify user identity</li>
                    <li>Communicate important updates</li>
                    <li>Ensure app security</li>
                </ul>

                <h3 className="text-content-subtitle">Contact Us</h3>
                <p className="text-content-paragraph">
                    If you have any questions about this Privacy Policy, please contact us at:<br />
                    Email: gullycinema@gmail.com<br />
                    Phone: 9000022211
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
